import { useParams } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'
import { RoleLevelDetailsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import JobLevelEmployeesDataCollection from 'modules/project_management/components/tables/JobLevelEmployeesDataCollection'

const RoleDetailsPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { jobLevelId } = useParams()

  const { data, loading, error } = useQuery(RoleLevelDetailsPageDocument, {
    variables: {
      companyId,
      resourceId: Number(jobLevelId),
      featureIds: [Features.projects_budget, Features.projects_costs],
    },
  })

  const isTotalProfitabilityEnabled = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_projects_total_profitability'
  )?.enabled

  const isBudgetFeatureEnabled = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_budget
  )?.available

  const isCostsFeatureEnabled = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_costs
  )?.available

  const canManageRates = !!data?.projectManagement._policies.rateManage.can
  const canSeeLaborCost = !!data?.projectManagement._policies.projectSeeLaborCost.can
  const canSeeRates = isBudgetFeatureEnabled && isCostsFeatureEnabled && canSeeLaborCost
  const rateId = data?.projectManagement.ratesConnection.nodes[0]?.id

  return (
    <ResponsivePage.Body
      variant="wide"
      loading={!data && loading}
      error={error}
      authorized={isTotalProfitabilityEnabled && canSeeRates}
    >
      <JobLevelEmployeesDataCollection
        canManageRates={canManageRates}
        referenceRateId={Number(rateId)}
      />
    </ResponsivePage.Body>
  )
}

export default RoleDetailsPage
